// components/ErrorReportButton.js
import React from 'react';
import { X, AlertTriangle } from 'lucide-react';
import { useLogError } from '../services/contexts/logErrorContext';
import { Button } from '@material-tailwind/react';

export const ErrorReportButton = ({ closeToast, data }) => {
    const { showReportDialog } = useLogError();

    const handleReportError = (e) => {
        e.stopPropagation();

        // Extract error data from toast props
        const errorData = data || {
            message: 'An error occurred',
            type: 'error',
            timestamp: new Date().toISOString()
        };

        showReportDialog(errorData);
    };

    return (
        <div className="flex items-center gap-2">
            <Button
                onClick={handleReportError}
                color='red'
                className="flex items-center gap-1 rounded-full"
                size='sm'
            >
                <AlertTriangle size={12} />Report
            </Button>
            <Button
                onClick={closeToast}
                variant='filled'
                className="flex items-center gap-1 rounded-full"
                size='sm'
            >
                <X size={12} /> Dismiss
            </Button>
        </div>
    );
};